import React from 'react';
import Main from './Main';
import Watchlist from './Watchlist';
import Meta from './Meta';
import CustomList from './CustomList';
import API from './API';
import Legal from './Legal';
import ScrollToTop from './ScrollToTop'
import Login from './Login';
import Perks from './Perks';
import { Switch, Route, BrowserRouter, Redirect, withRouter, Link } from 'react-router-dom';
import Helmet from 'react-helmet'
import images from './images.js'

function RouteWithTitle({ title, ...props }) {
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Route {...props} />
    </>
  )
}


const NoMatchPage = () => {
  return (
    <>
      <Helmet>
        <title>{'404 Not Found - Torrent Track'}</title>
        <meta
          name="description"
          content={'404 Not Found - Torrent Track'}
        />
      </Helmet>
      <center>
        <img src={images.surrender} alt="Torrent Track 404" style={{ width: '50%', maxWidth: '360px', marginTop: '40px' }} />
        <h3>404: No booty here</h3>
        <Link className={'main-links'} style={{ margin: '0', marginTop: '20px' }} to={'/movies/'}>Go home</Link>
      </center>
    </>
  )
}

function App() {
  return (
      <BrowserRouter>
        <ScrollToTop>
          <main>
            <Switch>
                <Route path="/" exact>
                  <Redirect to="/movies" />
                </Route>
                <Route path="/movies" exact>
                  <Redirect to="/movies/new" />
                </Route>
                <Route path="/series" exact>
                  <Redirect to="/series/new" />
                </Route>
                <Route path="other" exact>
                  <Redirect to="/other/new" />
                </Route>
                <Route path="/watchlist" exact>
                  <Redirect to="/watchlist/movies" />
                </Route>
                <Route path="/watchlist/movies" exact>
                  <Redirect to="/watchlist/movies/new" />
                </Route>
                <RouteWithTitle path="/movies/new" component={withRouter(Main)} />
                <RouteWithTitle path="/series/new" component={withRouter(Main)} />
                <RouteWithTitle path="/other/new" component={withRouter(Main)} />
                <RouteWithTitle path="/movies/popular" component={withRouter(Main)} />
                <RouteWithTitle path="/series/popular" component={withRouter(Main)} />
                <RouteWithTitle path="/other/popular" component={withRouter(Main)} />
                <RouteWithTitle path="/series/best/6mo" component={withRouter(Main)} />
                <RouteWithTitle path="/series/best/1yr" component={withRouter(Main)} />
                <RouteWithTitle path="/series/best/2yr" component={withRouter(Main)} />
                <RouteWithTitle path="/series/best/3yr" component={withRouter(Main)} />
                <RouteWithTitle path="/other/best/6mo" component={withRouter(Main)} />
                <RouteWithTitle path="/other/best/1yr" component={withRouter(Main)} />
                <RouteWithTitle path="/other/best/2yr" component={withRouter(Main)} />
                <RouteWithTitle path="/other/best/3yr" component={withRouter(Main)} />
                <RouteWithTitle path="/movies/best/3mo" component={withRouter(Main)} />
                <RouteWithTitle path="/movies/best/6mo" component={withRouter(Main)} />
                <RouteWithTitle path="/movies/best/1yr" component={withRouter(Main)} />
                <RouteWithTitle path="/movies/best/2yr" component={withRouter(Main)} />
                <RouteWithTitle path="/movies/best/3yr" component={withRouter(Main)} />
                <RouteWithTitle path="/movies/best" component={withRouter(Main)} />
                <RouteWithTitle path="/series/best" component={withRouter(Main)} />
                <RouteWithTitle path="/other/best" component={withRouter(Main)} />
                <RouteWithTitle path="/watchlist/movies/new" component={withRouter(Watchlist)} />
                <RouteWithTitle path="/watchlist/series/new" component={withRouter(Watchlist)} />
                <RouteWithTitle path="/watchlist/other/new" component={withRouter(Watchlist)} />
                <RouteWithTitle path="/watchlist/movies/best" component={withRouter(Watchlist)} />
                <RouteWithTitle path="/watchlist/series/best" component={withRouter(Watchlist)} />
                <RouteWithTitle path="/watchlist/other/best" component={withRouter(Watchlist)} />
                <RouteWithTitle path="/title/" component={withRouter(Meta)} />
                <RouteWithTitle exact path="/api-docs" component={withRouter(API)} />
                <RouteWithTitle exact path="/legal" component={withRouter(Legal)} />
                <RouteWithTitle exact path="/login" component={withRouter(Login)} />
                <RouteWithTitle exact path="/perks" component={withRouter(Perks)} />
                <RouteWithTitle path="/custom-list" component={withRouter(CustomList)} />
                <RouteWithTitle component={NoMatchPage} />
            </Switch>
          </main>
        </ScrollToTop>
      </BrowserRouter>
  );
}

export default App;
